import axios from 'axios';
import router from '@/router';

import auth from '@/utils/auth';

import {
  SAVE_COMPANY_REVIEW,
  SAVE_COMPANY_REVIEW_ERROR,
  SAVE_COMPANY_REVIEW_SUCCESS,

  GET_COMPANY_REVIEW,
  GET_COMPANY_REVIEW_ERROR,
  GET_COMPANY_REVIEW_SUCCESS,

  GET_COMPANY,
  GET_COMPANY_ERROR,
  GET_COMPANY_SUCCESS,

  DELETE_COMPANY,
  DELETE_COMPANY_ERROR,
  DELETE_COMPANY_SUCCESS,

  SET_RATINGS,
  SET_RATINGS_ERROR,
  SET_RATINGS_SUCCESS,

  GET_CATEGORY,
  GET_CATEGORY_ERROR,
  GET_CATEGORY_SUCCESS,

  GET_CATEGORY_BYID,
  GET_CATEGORY_BYID_ERROR,
  GET_CATEGORY_BYID_SUCCESS,

  DELETE_CATEGORY,
  DELETE_CATEGORY_ERROR,
  DELETE_CATEGORY_SUCCESS,

  CREATE_CATEGORY,
  CREATE_CATEGORY_ERROR,
  CREATE_CATEGORY_SUCCESS,

} from './constants';

export default {

  async [DELETE_COMPANY]({ commit }, companiesReviewID) {
    try {
      commit(DELETE_COMPANY);
      await axios({
        url: `${process.env.API_URL}/api/companies-review/${companiesReviewID}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_COMPANY_SUCCESS);
      router.push({ name: 'Coowner Review Listing' });
    } catch (err) {
      commit(DELETE_COMPANY_ERROR, err);
    }
  },

  async [SAVE_COMPANY_REVIEW]({ commit }, data) {
    try {
      commit(SAVE_COMPANY_REVIEW);
      let url = `${process.env.API_URL}/api/companies-review`;
      let method = 'POST';
      if (data.companiesReviewID) {
        url = `${url}/${data.companiesReviewID}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_COMPANY_REVIEW_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_COMPANY_REVIEW_ERROR, err);
    }
  },

  async [SET_RATINGS]({ commit }, data) {
    const ratingVal = {
      rating: data.rating,
    };
    try {
      commit(SET_RATINGS);
      const url = `${process.env.API_URL}/api/companies-review/${data.companiesReviewID}/rating`;
      const method = 'PUT';
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data: ratingVal,
      });
      commit(SET_RATINGS_SUCCESS, response.data);
    } catch (err) {
      commit(SET_RATINGS_ERROR, err);
    }
  },

  async [GET_COMPANY_REVIEW]({ commit }, args) {
    try {
      commit(GET_COMPANY_REVIEW);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/companies-review`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          limit: args.limit || localStorage.pageLimit || '50',
          page: args.page || 0,
          // sortField: args.sortField || 'rating',
          // sortDir: args.sortDir || 'DESC',
          filters: args.filters ? `categories==${args.filters}` : undefined,
        },
      });
      commit(GET_COMPANY_REVIEW_SUCCESS, response.data);
    } catch (err) {
      commit(GET_COMPANY_REVIEW_ERROR, err);
    }
  },

  async [GET_COMPANY]({ commit }, companiesReviewID) {
    try {
      commit(GET_COMPANY);
      const response = await axios({
        url: `${process.env.API_URL}/api/companies-review/${companiesReviewID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_COMPANY_SUCCESS, response.data);
    } catch (err) {
      commit(GET_COMPANY_ERROR, err);
    }
  },

  async [GET_CATEGORY]({ commit }, syndicateID) {
    try {
      commit(GET_CATEGORY);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${syndicateID}/companies-categories`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_CATEGORY_SUCCESS, response.data);
    } catch (err) {
      commit(GET_CATEGORY_ERROR, err);
    }
  },
  async [GET_CATEGORY_BYID]({ commit }, categoryID) {
    try {
      commit(GET_CATEGORY_BYID);
      const response = await axios({
        url: `${process.env.API_URL}/api/companies-categories/${categoryID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_CATEGORY_BYID_SUCCESS, response.data);
    } catch (err) {
      commit(GET_CATEGORY_BYID_ERROR, err);
    }
  },

  async [CREATE_CATEGORY]({ commit }, data) {
    try {
      commit(CREATE_CATEGORY);
      let url = `${process.env.API_URL}/api/companies-categories`;
      let method = 'POST';
      if (data.companiesCategoriesID) {
        url = `${url}/${data.companiesCategoriesID}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(CREATE_CATEGORY_SUCCESS, response.data);
      // if (method === 'POST') {
      //   this.$router.push({ name: 'Coowner', params: { coownerID: response.data.coownerID } });
      // }
    } catch (err) {
      commit(CREATE_CATEGORY_ERROR, err.response);
    }
  },

  async [DELETE_CATEGORY]({ commit }, data) {
    try {
      commit(DELETE_CATEGORY);
      await axios({
        url: `${process.env.API_URL}/api/companies-categories/${data}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_CATEGORY_SUCCESS);
    } catch (err) {
      commit(DELETE_CATEGORY_ERROR, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Companies/actions.js